

import React from 'react';
import { CONFIG } from 'config/config';
import { Text, UiWrapper, View } from '@coinscrap/webapp-core';

import BeneficiaryBox from 'components/BeneficiaryBox/BeneficiaryBox';
import TextSpan from 'components/TextSpan/TextSpan';

export const BeneficiaryList = ({ beneficiaries, setBeneficiaries, totalPercentage, onEdit }) => {
	const { openModal } = UiWrapper.use();

	return (
		<View>
			<Text labelInputSt style={{ alignSelf: 'flex-start', marginTop: 20 }}>
				Beneficiarios añadidos
				{totalPercentage !== 100 && (
					<TextSpan
						style={{
							marginLeft: 10,
							color: CONFIG.colors.danger,
						}}
					>
						Debes asignar un 100 %
					</TextSpan>
				)}
			</Text>

			{beneficiaries.length > 0 && (
				<View style={{ gap: '20px', marginBottom: '20px' }}>
					{beneficiaries.map((ben, index) => (
						<BeneficiaryBox
							key={`ben-${ben.dni}`}
							ben={ben}
							onDelete={() => {
								setBeneficiaries(
									beneficiaries.filter(function (benf) {
										return benf.dni !== ben.dni;
									}),
								);
							}}
							onEdit={() => onEdit(ben)}
						/>
					))}
				</View>
			)}
		</View>
	);
};
